const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.33,232.24s-26.05-3.09-43.19,10.28-31.88,69.24-31.54,96,10.29,40.11,35.31,51.07,71.63,6.86,97.68-1.37,34.62-37,34.28-52.44-17.48-33.25-23.31-37-22.28-11.65-30.5-24S228.83,235.67,210.33,232.24Z",
    style: {
      fill: "#92BFE3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.4,235s-9.33,3-10.67,5.33S198.4,259,198.4,261s1.17-1.17,2.17-3.5,4.5-5.84,5.66-5.5,1.84,1.66,1.84,3.83,2.66,5.17,5,6.83,4.5,3.34,4.5,3.34,4.83-7,6-8.84,1-5.66,1.16-7,3.17,3.67,3.84,2.34-1.5-2.5-3.84-6.17-1.66-7.5-5.16-10.17S212.07,234.32,209.4,235Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.32,302.57s-5.75-8.25-12.75-9-15.5,5-15.75,7-2,12.75-.75,14.25,6,2.75,15.25-.25S186.32,307.82,187.32,302.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.82,304.82s-9.38,3.72-9.75,11c-.21,4,6.5,5.75,13.5,5.75s17-8.75,23.5-12.5,21.5-12.5,23.25-13.25,7.75,1.25,10.25,2a33.81,33.81,0,0,0,7.25.75s3.5,5.5,5.25,5.5-3.75-8.25-4.5-10-13-5.75-14.5-5.75-36.5,8.75-41.75,10.75S167.82,304.82,167.82,304.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "233.32 292.07 206.54 311.01 267.79 309.26 288.32 292.32 233.32 292.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.57,310.82s22-19.25,43.75-25.75,26.25-5.5,25.75,4.25-11,60.75-18,73.75-15.75,36.75-15.5,41.25,8.75,17.75,16.25,22.5,6.75,10.5,2,11.5-10.25,2.75-26.5-7.75-23-25.5-22-29.25,11.5-8.75,15.75-16.25,11.25-35.5,11.75-48.25a75.76,75.76,0,0,1,5-23.5s-27.5,5-35.5,10Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.07,385.07c-.32.56-.68,1.1-1.06,1.64a25.69,25.69,0,0,1,14.06,5.86,44.18,44.18,0,0,1,3.42,3.31c4.79-6.44,10.18-26.75,16.26-35.11,15.71-21.59,14.82-61.7,15.32-71.45s-4-10.75-25.75-4.25-43.75,25.75-43.75,25.75l2.75,12.5c8-5,35.5-10,35.5-10a75.76,75.76,0,0,0-5,23.5C286.32,349.57,279.32,377.57,275.07,385.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.07,314.82s-8,4.5-10.75,9.5,9.08,13.33,21.58,12.83,35.42-14.08,35.42-14.08.25,22,4.5,30,23.75,27.5,31.5,32.5,33.75,23.75,37.75,26.75,11.5,8.5,13.25,8.75,20-22,24.25-29.5,8-23.25,6.5-26.75-4.5-.5-7.5,2-30.5,20.75-33,22a27.44,27.44,0,0,1-4.25,1.75s-22.5-21.5-34.5-38-13-37.75-17.5-45.75-11-11.5-20.75-10.5S204.57,302.57,188.07,314.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.77,389.07c-5.29-5.16-25.12-31.77-32.95-47.07-11.47-22.42-12.71-30.06-17.21-38.06s-11.29-8.62-21-7.62-27.2,2.81-48.6,14.95c0,0-9,4.88-11.74,9.88s7.27,17.59,24.67,16c12.46-1.14,35.42-14.08,35.42-14.08s.25,22,4.5,30,23.75,27.5,31.5,32.5c4.91,3.17,17.16,11.87,26.49,18.57C299.15,395.77,303.28,391.19,305.77,389.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.57,391.57c4.25-7.5,8-23.25,6.5-26.75-.87-2-2.24-1.87-3.83-.89,1.05,4.67,0,13.68-5.17,23.39-4.61,8.66-18.85,24-26,31.42a16.78,16.78,0,0,0,4.27,2.33C323.07,421.32,341.32,399.07,345.57,391.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.82,426.82a32.67,32.67,0,0,1-6.66-6c-5.16-2.2-12.05-5-18.09-8.76-6.5-4-5-6.5-8.75-10.25-2.88-2.88-8.54-3.25-11-3.27a6.91,6.91,0,0,0-2,2.77c-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75S313.32,431.57,305.82,426.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.07,428.57c-6.5-3.75-19.75-6.25-28.25-12s-6.25-10.75-12.5-14.75a6.35,6.35,0,0,0-7-.4c-.87,3.9,5.9,18.73,22,29.15s21.75,8.75,26.5,7.75c3.16-.67,4.53-3.43,2.9-6.6A13.64,13.64,0,0,0,307.07,428.57Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.72,222s1.17,12.63,1.66,16.62,1.6,15.45,2.75,19.24,7.42,10.38,8,8.86,3.7-11.83,2.46-18-1.62-11.44-.85-13,3.54-3.31,3.54-3.31a100.43,100.43,0,0,1-9.39-5.47C210.47,224,207.34,220.67,206.72,222Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-14--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.26,223.83s7.2,6,12.72,8.2,14,2.06,15.21-.81-2.1-25.6-4.95-31.58-5.89-6.08-10.92-6.54-15.09,3.64-16.86,8.5.25,11.74,1.71,15.82A30,30,0,0,0,206.26,223.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-15--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.41,217.87s-3.23-4.66-6.63-2.79-.76,8.52,1.29,10.83,6-2,6.41-3.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.46,333.1c7.48-61.05-28.74-142.2-66.3-175.7-67.79-60.5-124.11-48.8-167.91-27.13s-50.07,94-80.31,126.73-47.46,76.75-1.56,120.58,82.91,21.55,130.89,18.78,111.59,19.1,146,.07C395.32,383.15,407.16,360.09,410.46,333.1Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.46,333.1c7.48-61.05-28.74-142.2-66.3-175.7-67.79-60.5-124.11-48.8-167.91-27.13s-50.07,94-80.31,126.73-47.46,76.75-1.56,120.58,82.91,21.55,130.89,18.78,111.59,19.1,146,.07C395.32,383.15,407.16,360.09,410.46,333.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Background--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 220.61,
    y1: 330.95,
    x2: 220.61,
    y2: 106.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "74.39 333.18 216.28 333.18 431.85 402.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,327.9H129.2V165.84h20.23l-8.73-31.51H114.5l-8.73,31.51H126V327.9h-9.83a9.6,9.6,0,0,0-9.59,9.42s0,.05,0,.07v0s0,.06,0,.08h0c.29,2.26,9.57,4.08,21,4.08s20.71-1.82,21-4.08h0A9.6,9.6,0,0,0,139,327.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,94.86V285.68l143.67,23.64V71.22ZM409.53,149.5l-73,4.14V87.34l73-11.62Zm-73,11.11,73-3.35v66.66l-73-3.41Zm-5.92,59.62L272,217.5V163.57l58.56-2.68Zm0-131.95V154L272,157.29V97.6ZM272,223.78l58.56,3.37v65.11L272,282.94Zm64.48,69.42V227.49l73,4.2v73.13Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.04,
    cy: 390.14,
    rx: 114.95,
    ry: 35.81,
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.04,
    cy: 390.14,
    rx: 114.95,
    ry: 35.81,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.33,232.24s-26.05-3.09-43.19,10.28-31.88,69.24-31.54,96,10.29,40.11,35.31,51.07,71.63,6.86,97.68-1.37,34.62-37,34.28-52.44-17.48-33.25-23.31-37-22.28-11.65-30.5-24S228.83,235.67,210.33,232.24Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.37,386.37c-9.85-1.33-21.53-4-30.37-9.37-18.67-11.33-23.33-32.67-30-40.67s-18.67-7.33-24-16,3.33-72.66-12-76.66a34.89,34.89,0,0,0-9.57-1.37c-.09.08-.2.14-.29.22-17.14,13.37-31.88,69.24-31.54,96s10.29,40.11,35.31,51.07,71.63,6.86,97.68-1.37A41.12,41.12,0,0,0,273.37,386.37Z",
    style: {
      opacity: 0.13
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.33,232.24s-26.05-3.09-43.19,10.28-31.88,69.24-31.54,96,10.29,40.11,35.31,51.07,71.63,6.86,97.68-1.37,34.62-37,34.28-52.44-17.48-33.25-23.31-37-22.28-11.65-30.5-24S228.83,235.67,210.33,232.24Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.07,244.32s-17,3.25-20,6.25-15.5,50-15.5,50a18.6,18.6,0,0,1,10.5.5c5,2,5.5,7.25,6,9.75a89.46,89.46,0,0,1,.75,9s50.53-4.51,61.28-7,27.11-3.65,27.11-3.65-27.64-62.34-31.89-64.59-22-2.5-24.5-2S200.07,244.32,200.07,244.32Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.32,
    y1: 302.07,
    x2: 187.57,
    y2: 267.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.57,
    y1: 276.57,
    x2: 192.32,
    y2: 269.07,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.82,281.07s16.25-5.25,27-5.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.16,266.74l-1.09,8.33s2.75,0,3,1.25a3.32,3.32,0,0,1-1,2.5s7.75,4.25,8.75,9.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.4,235s-9.33,3-10.67,5.33S198.4,259,198.4,261s1.17-1.17,2.17-3.5,4.5-5.84,5.66-5.5,1.84,1.66,1.84,3.83,2.66,5.17,5,6.83,4.5,3.34,4.5,3.34,4.83-7,6-8.84,1-5.66,1.16-7,3.17,3.67,3.84,2.34-1.5-2.5-3.84-6.17-1.66-7.5-5.16-10.17S212.07,234.32,209.4,235Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.73,240.32c-.88,1.56-.74,9.34-.54,15,2.13-2.74,6.52-7.92,9.06-6.94,3.24,1.25,4.48,10.46,4.48,10.46L209.54,235l-.14,0S200.07,238,198.73,240.32Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.73,240.32c-.88,1.56-.74,9.34-.54,15,2.13-2.74,6.52-7.92,9.06-6.94,3.24,1.25,4.48,10.46,4.48,10.46L209.54,235l-.14,0S200.07,238,198.73,240.32Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.4,235s-9.33,3-10.67,5.33S198.4,259,198.4,261s1.17-1.17,2.17-3.5,4.5-5.84,5.66-5.5,1.84,1.66,1.84,3.83,2.66,5.17,5,6.83,4.5,3.34,4.5,3.34,4.83-7,6-8.84,1-5.66,1.16-7,3.17,3.67,3.84,2.34-1.5-2.5-3.84-6.17-1.66-7.5-5.16-10.17S212.07,234.32,209.4,235Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.32,302.57s-5.75-8.25-12.75-9-15.5,5-15.75,7-2,12.75-.75,14.25,6,2.75,15.25-.25S186.32,307.82,187.32,302.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.93,314.56s-2-5.72-1-7.71,5-5,7.47-8-5.83,1.69-6.23,0c-.31-1.36,4.39-4.08,6.24-5.09-5.82,1.12-11.39,5.17-11.59,6.78-.25,2-2,12.75-.75,14.25.64.77,2.23,1.48,4.88,1.57C163.55,315.33,163.93,314.56,163.93,314.56Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93,314.56s-2-5.72-1-7.71,5-5,7.47-8-5.83,1.69-6.23,0c-.31-1.36,4.39-4.08,6.24-5.09-5.82,1.12-11.39,5.17-11.59,6.78-.25,2-2,12.75-.75,14.25.64.77,2.23,1.48,4.88,1.57C163.55,315.33,163.93,314.56,163.93,314.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.32,302.57s-5.75-8.25-12.75-9-15.5,5-15.75,7-2,12.75-.75,14.25,6,2.75,15.25-.25S186.32,307.82,187.32,302.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.82,304.82s-9.38,3.72-9.75,11c-.21,4,6.5,5.75,13.5,5.75s17-8.75,23.5-12.5,21.5-12.5,23.25-13.25,7.75,1.25,10.25,2a33.81,33.81,0,0,0,7.25.75s3.5,5.5,5.25,5.5-3.75-8.25-4.5-10-13-5.75-14.5-5.75-36.5,8.75-41.75,10.75S167.82,304.82,167.82,304.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.43,303.78c14.29-7.15,34.64-15.46,34.64-15.46-1.5,0-36.5,8.75-41.75,10.75s-12.5,5.75-12.5,5.75-9.38,3.72-9.75,11c-.21,4,6.5,5.75,13.5,5.75s17-8.75,23.5-12.5l3.94-2.28C189.46,308,176.69,309.14,187.43,303.78Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.43,303.78c14.29-7.15,34.64-15.46,34.64-15.46-1.5,0-36.5,8.75-41.75,10.75s-12.5,5.75-12.5,5.75-9.38,3.72-9.75,11c-.21,4,6.5,5.75,13.5,5.75s17-8.75,23.5-12.5l3.94-2.28C189.46,308,176.69,309.14,187.43,303.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.82,304.82s-9.38,3.72-9.75,11c-.21,4,6.5,5.75,13.5,5.75s17-8.75,23.5-12.5,21.5-12.5,23.25-13.25,7.75,1.25,10.25,2a33.81,33.81,0,0,0,7.25.75s3.5,5.5,5.25,5.5-3.75-8.25-4.5-10-13-5.75-14.5-5.75-36.5,8.75-41.75,10.75S167.82,304.82,167.82,304.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.94,249.22l-7.62,42.85,55,.25,8.18-40.64a2.53,2.53,0,0,0-2.4-3l-50.6-1.52A2.52,2.52,0,0,0,240.94,249.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.32 292.07 206.54 311.01 267.79 309.26 288.32 292.32 233.32 292.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "233.32 292.07 206.54 311.01 267.79 309.26 288.32 292.32 233.32 292.07",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.32 292.07 206.54 311.01 267.79 309.26 288.32 292.32 233.32 292.07",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "233.32 292.07 206.54 311.01 267.79 309.26 288.32 292.32 233.32 292.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.57,310.82s22-19.25,43.75-25.75,26.25-5.5,25.75,4.25-11,60.75-18,73.75-15.75,36.75-15.5,41.25,8.75,17.75,16.25,22.5,6.75,10.5,2,11.5-10.25,2.75-26.5-7.75-23-25.5-22-29.25,11.5-8.75,15.75-16.25,11.25-35.5,11.75-48.25a75.76,75.76,0,0,1,5-23.5s-27.5,5-35.5,10Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.57,310.82s22-19.25,43.75-25.75,26.25-5.5,25.75,4.25-11,60.75-18,73.75-15.75,36.75-15.5,41.25,8.75,17.75,16.25,22.5,6.75,10.5,2,11.5-10.25,2.75-26.5-7.75-23-25.5-22-29.25,11.5-8.75,15.75-16.25,11.25-35.5,11.75-48.25a75.76,75.76,0,0,1,5-23.5s-27.5,5-35.5,10Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.57,310.82s22-19.25,43.75-25.75,26.25-5.5,25.75,4.25-11,60.75-18,73.75-15.75,36.75-15.5,41.25,8.75,17.75,16.25,22.5,6.75,10.5,2,11.5-10.25,2.75-26.5-7.75-23-25.5-22-29.25,11.5-8.75,15.75-16.25,11.25-35.5,11.75-48.25a75.76,75.76,0,0,1,5-23.5s-27.5,5-35.5,10Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.57,310.82s22-19.25,43.75-25.75,26.25-5.5,25.75,4.25-11,60.75-18,73.75-15.75,36.75-15.5,41.25,8.75,17.75,16.25,22.5,6.75,10.5,2,11.5-10.25,2.75-26.5-7.75-23-25.5-22-29.25,11.5-8.75,15.75-16.25,11.25-35.5,11.75-48.25a75.76,75.76,0,0,1,5-23.5s-27.5,5-35.5,10Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.07,385.07c-.32.56-.68,1.1-1.06,1.64a25.69,25.69,0,0,1,14.06,5.86,44.18,44.18,0,0,1,3.42,3.31,218.66,218.66,0,0,1,13.58-32.81c7-13,17.5-64,18-73.75s-4-10.75-25.75-4.25-43.75,25.75-43.75,25.75l2.75,12.5c8-5,35.5-10,35.5-10a75.76,75.76,0,0,0-5,23.5C286.32,349.57,279.32,377.57,275.07,385.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.07,385.07c-.32.56-.68,1.1-1.06,1.64a25.69,25.69,0,0,1,14.06,5.86,44.18,44.18,0,0,1,3.42,3.31c4.79-6.44,10.18-26.75,16.26-35.11,15.71-21.59,14.82-61.7,15.32-71.45s-4-10.75-25.75-4.25-43.75,25.75-43.75,25.75l2.75,12.5c8-5,35.5-10,35.5-10a75.76,75.76,0,0,0-5,23.5C286.32,349.57,279.32,377.57,275.07,385.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.07,385.07c-.32.56-.68,1.1-1.06,1.64a25.69,25.69,0,0,1,14.06,5.86,44.18,44.18,0,0,1,3.42,3.31c4.79-6.44,10.18-26.75,16.26-35.11,15.71-21.59,14.82-61.7,15.32-71.45s-4-10.75-25.75-4.25-43.75,25.75-43.75,25.75l2.75,12.5c8-5,35.5-10,35.5-10a75.76,75.76,0,0,0-5,23.5C286.32,349.57,279.32,377.57,275.07,385.07Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5,288c-.39-3.55-39.06,12.82-55.37,19.88-2.26,1.8-3.56,2.94-3.56,2.94l2.75,12.5c8-5,35.5-10,35.5-10a75.76,75.76,0,0,0-5,23.5c-.5,12.75-7.5,40.75-11.75,48.25-.32.56-.68,1.1-1.06,1.64a28.32,28.32,0,0,1,8,2.07C288,376,294.45,361.13,297.5,349.5,303,328.5,313,292.5,312.5,288Z",
    style: {
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,313.32s7.5-15.25,14-21.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.07,385.07c-.32.56-.68,1.1-1.06,1.64a25.69,25.69,0,0,1,14.06,5.86,44.18,44.18,0,0,1,3.42,3.31c4.79-6.44,10.18-26.75,16.26-35.11,15.71-21.59,14.82-61.7,15.32-71.45s-4-10.75-25.75-4.25-43.75,25.75-43.75,25.75l2.75,12.5c8-5,35.5-10,35.5-10a75.76,75.76,0,0,0-5,23.5C286.32,349.57,279.32,377.57,275.07,385.07Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.61,331a86,86,0,0,0,23.65-4.45c11.31-4.12-9.26-11.66-17.14-7.54A11.71,11.71,0,0,0,220.61,331Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,314.82s-8,4.5-10.75,9.5,9.08,13.33,21.58,12.83,35.42-14.08,35.42-14.08.25,22,4.5,30,23.75,27.5,31.5,32.5,33.75,23.75,37.75,26.75,11.5,8.5,13.25,8.75,20-22,24.25-29.5,8-23.25,6.5-26.75-4.5-.5-7.5,2-30.5,20.75-33,22a27.44,27.44,0,0,1-4.25,1.75s-22.5-21.5-34.5-38-13-37.75-17.5-45.75-11-11.5-20.75-10.5S204.57,302.57,188.07,314.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.85,402c6.68,4.78,12.49,9,14.22,10.3,4,3,11.5,8.5,13.25,8.75.62.09,3.32-2.66,6.73-6.57l-28.63-18.42Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.85,402c6.68,4.78,12.49,9,14.22,10.3,4,3,11.5,8.5,13.25,8.75.62.09,3.32-2.66,6.73-6.57l-28.63-18.42Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,314.82s-8,4.5-10.75,9.5,9.08,13.33,21.58,12.83,35.42-14.08,35.42-14.08.25,22,4.5,30,23.75,27.5,31.5,32.5,33.75,23.75,37.75,26.75,11.5,8.5,13.25,8.75,20-22,24.25-29.5,8-23.25,6.5-26.75-4.5-.5-7.5,2-30.5,20.75-33,22a27.44,27.44,0,0,1-4.25,1.75s-22.5-21.5-34.5-38-13-37.75-17.5-45.75-11-11.5-20.75-10.5S204.57,302.57,188.07,314.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,389.07c-5.29-5.16-25.12-31.77-32.95-47.07-11.47-22.42-12.71-30.06-17.21-38.06s-11.29-8.62-21-7.62-27.2,2.81-48.6,14.95c0,0-9,4.88-11.74,9.88s7.27,17.59,24.67,16c12.46-1.14,35.42-14.08,35.42-14.08s.25,22,4.5,30,23.75,27.5,31.5,32.5c4.91,3.17,17.16,11.87,26.49,18.57C299.15,395.77,303.28,391.19,305.77,389.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.77,389.07c-5.29-5.16-25.12-31.77-32.95-47.07-11.47-22.42-12.71-30.06-17.21-38.06s-11.29-8.62-21-7.62-27.2,2.81-48.6,14.95c0,0-9,4.88-11.74,9.88s7.27,17.59,24.67,16c12.46-1.14,35.42-14.08,35.42-14.08s.25,22,4.5,30,23.75,27.5,31.5,32.5c4.91,3.17,17.16,11.87,26.49,18.57C299.15,395.77,303.28,391.19,305.77,389.07Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.5,353.5c-7.5-19-3-57-24-52-15.3,3.64-43.35,16.58-57.44,23.33,1.67,5.74,10.87,13.6,24.84,12.32,12.46-1.14,35.42-14.08,35.42-14.08s.25,22,4.5,30,23.75,27.5,31.5,32.5c4.91,3.17,17.16,11.87,26.49,18.57a35.74,35.74,0,0,1,3.49-8.37C281.68,382,259.69,364.11,255.5,353.5Z",
    style: {
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.32,
    y1: 323.07,
    x2: 233.57,
    y2: 310.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,389.07c-5.29-5.16-25.12-31.77-32.95-47.07-11.47-22.42-12.71-30.06-17.21-38.06s-11.29-8.62-21-7.62-27.2,2.81-48.6,14.95c0,0-9,4.88-11.74,9.88s7.27,17.59,24.67,16c12.46-1.14,35.42-14.08,35.42-14.08s.25,22,4.5,30,23.75,27.5,31.5,32.5c4.91,3.17,17.16,11.87,26.49,18.57C299.15,395.77,303.28,391.19,305.77,389.07Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,412.32c4,3,11.5,8.5,13.25,8.75s20-22,24.25-29.5,8-23.25,6.5-26.75-4.5-.5-7.5,2-30.5,20.75-33,22c-.66.33-1.26.6-1.79.83-.72,1.37-1.6,3.49-1,4.92,1,2.25,5.25,5.25,5.25,5.25l-7.57,11.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57,391.57c4.25-7.5,8-23.25,6.5-26.75-.87-2-2.24-1.87-3.83-.89,1.05,4.67,0,13.68-5.17,23.39-4.61,8.66-18.85,24-26,31.42a16.78,16.78,0,0,0,4.27,2.33C323.07,421.32,341.32,399.07,345.57,391.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.57,421l.22-.11.06-.05a2.14,2.14,0,0,0,.34-.24l.12-.1.29-.24.16-.15.39-.36.24-.23.33-.32.28-.28.28-.28.71-.75.12-.12.44-.48.18-.19c.52-.57,1.08-1.19,1.66-1.85l0-.05.62-.7h0l-4.37-2.81c-2.48,2.7-4.79,5.14-6.63,7.05h0l.67.44.1.06.62.39h0l1,.57.28.16.28.15.32.16.21.1a2.58,2.58,0,0,0,.31.13l.15.06a1.52,1.52,0,0,0,.36.1.38.38,0,0,0,.19,0Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.57,421l.22-.11.06-.05a2.14,2.14,0,0,0,.34-.24l.12-.1.29-.24.16-.15.39-.36.24-.23.33-.32.28-.28.28-.28.71-.75.12-.12.44-.48.18-.19c.52-.57,1.08-1.19,1.66-1.85l0-.05.62-.7h0l-4.37-2.81c-2.48,2.7-4.79,5.14-6.63,7.05h0l.67.44.1.06.62.39h0l1,.57.28.16.28.15.32.16.21.1a2.58,2.58,0,0,0,.31.13l.15.06a1.52,1.52,0,0,0,.36.1.38.38,0,0,0,.19,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.57,391.57c4.25-7.5,8-23.25,6.5-26.75-.87-2-2.24-1.87-3.83-.89,1.05,4.67,0,13.68-5.17,23.39-4.61,8.66-18.85,24-26,31.42a16.78,16.78,0,0,0,4.27,2.33C323.07,421.32,341.32,399.07,345.57,391.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.82,426.82c-7.5-4.75-16-18-16.25-22.5a7.1,7.1,0,0,1,.12-1.47,7.15,7.15,0,0,0-4.12,1.47,95.58,95.58,0,0,0-9.75-7.75,20.42,20.42,0,0,0-9-2.69c-3.63,3-7,5.4-7.53,7.44-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75S313.32,431.57,305.82,426.82Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.82,426.82a32.67,32.67,0,0,1-6.66-6c-5.16-2.2-12.05-5-18.09-8.76-6.5-4-5-6.5-8.75-10.25-2.88-2.88-8.54-3.25-11-3.27a6.91,6.91,0,0,0-2,2.77c-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75S313.32,431.57,305.82,426.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.82,426.82a32.67,32.67,0,0,1-6.66-6c-5.16-2.2-12.05-5-18.09-8.76-6.5-4-5-6.5-8.75-10.25-2.88-2.88-8.54-3.25-11-3.27a6.91,6.91,0,0,0-2,2.77c-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75S313.32,431.57,305.82,426.82Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.82,426.82a32.67,32.67,0,0,1-6.66-6c-5.16-2.2-12.05-5-18.09-8.76-6.5-4-5-6.5-8.75-10.25-2.88-2.88-8.54-3.25-11-3.27a6.91,6.91,0,0,0-2,2.77c-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75S313.32,431.57,305.82,426.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.82,426.82a32.67,32.67,0,0,1-6.66-6c-5.16-2.2-12.05-5-18.09-8.76-6.5-4-5-6.5-8.75-10.25-2.88-2.88-8.54-3.25-11-3.27a6.91,6.91,0,0,0-2,2.77c-1,3.75,5.75,18.75,22,29.25s21.75,8.75,26.5,7.75S313.32,431.57,305.82,426.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.07,428.57c-6.5-3.75-19.75-6.25-28.25-12s-6.25-10.75-12.5-14.75a6.35,6.35,0,0,0-7-.4c-.87,3.9,5.9,18.73,22,29.15s21.75,8.75,26.5,7.75c3.16-.67,4.53-3.43,2.9-6.6A13.64,13.64,0,0,0,307.07,428.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.07,428.57c-6.5-3.75-19.75-6.25-28.25-12s-6.25-10.75-12.5-14.75a6.35,6.35,0,0,0-7-.4c-.87,3.9,5.9,18.73,22,29.15s21.75,8.75,26.5,7.75c3.16-.67,4.53-3.43,2.9-6.6A13.64,13.64,0,0,0,307.07,428.57Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.07,428.57c-6.5-3.75-19.75-6.25-28.25-12s-6.25-10.75-12.5-14.75a6.35,6.35,0,0,0-7-.4c-.87,3.9,5.9,18.73,22,29.15s21.75,8.75,26.5,7.75c3.16-.67,4.53-3.43,2.9-6.6A13.64,13.64,0,0,0,307.07,428.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.49,380.75s4.8-5.83,5.48-1.37-.34,12.68-3.77,15.76-5.14-1.71-5.14-1.71l2.06-2.74s1.71,3.43,3.08-2.06-2.74-4.8-2.74-4.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82,402.69c-2.84,2.1-12.1,2.1-14.93,0-6-4.45-5-25.95-5-25.95h24.86S184.83,398.24,178.82,402.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.61,372.52c0-2.7,2.51-2.7,2.51-5.41s-2.51-2.71-2.51-5.41,2.51-2.71,2.51-5.42-2.51-2.71-2.51-5.42,2.51-2.71,2.51-5.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,372.52c0-2,2.51-2,2.51-4.11s-2.51-2.05-2.51-4.11,2.51-2.05,2.51-4.11-2.51-2.06-2.51-4.12,2.51-2.05,2.51-4.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.65,372.52c0-2.7,2.5-2.7,2.5-5.41s-2.5-2.71-2.5-5.41,2.5-2.71,2.5-5.42-2.5-2.71-2.5-5.42,2.5-2.71,2.5-5.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,376.74c0,.63-5.56,1.13-12.43,1.13s-12.43-.5-12.43-1.13,5.56-1.13,12.43-1.13S183.77,376.11,183.77,376.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.72,222s1.17,12.63,1.66,16.62,1.6,15.45,2.75,19.24,7.42,10.38,8,8.86,3.7-11.83,2.46-18-1.62-11.44-.85-13,3.54-3.31,3.54-3.31a100.43,100.43,0,0,1-9.39-5.47C210.47,224,207.34,220.67,206.72,222Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.77,233.09l-1-1.94c-1.84-1-4.4-2.48-6.83-4.11-4.45-3-7.58-6.37-8.2-5,0,0,1.17,12.63,1.66,16.62s1.6,15.45,2.75,19.24a12.93,12.93,0,0,0,1.61,3.12c-1.21-7.54.1-21.16.1-21.16Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.77,233.09l-1-1.94c-1.84-1-4.4-2.48-6.83-4.11-4.45-3-7.58-6.37-8.2-5,0,0,1.17,12.63,1.66,16.62s1.6,15.45,2.75,19.24a12.93,12.93,0,0,0,1.61,3.12c-1.21-7.54.1-21.16.1-21.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.72,222s1.17,12.63,1.66,16.62,1.6,15.45,2.75,19.24,7.42,10.38,8,8.86,3.7-11.83,2.46-18-1.62-11.44-.85-13,3.54-3.31,3.54-3.31a100.43,100.43,0,0,1-9.39-5.47C210.47,224,207.34,220.67,206.72,222Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.26,223.83s7.2,6,12.72,8.2,14,2.06,15.21-.81-2.1-25.6-4.95-31.58-5.89-6.08-10.92-6.54-15.09,3.64-16.86,8.5.25,11.74,1.71,15.82A30,30,0,0,0,206.26,223.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-14--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.19,223.56C216.64,216,216,204.1,216,200.93c0-2.45,6.38-5.14,9.29-6.24-1.91-1.18-4.13-1.33-7-1.59-5-.45-15.09,3.64-16.86,8.5s.25,11.74,1.71,15.82a30,30,0,0,0,3.09,6.41s7.2,6,12.72,8.2a22.91,22.91,0,0,0,12,1.15C227,231.69,220.89,228.61,219.19,223.56Z",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19,223.56C216.64,216,216,204.1,216,200.93c0-2.45,6.38-5.14,9.29-6.24-1.91-1.18-4.13-1.33-7-1.59-5-.45-15.09,3.64-16.86,8.5s.25,11.74,1.71,15.82a30,30,0,0,0,3.09,6.41s7.2,6,12.72,8.2a22.91,22.91,0,0,0,12,1.15C227,231.69,220.89,228.61,219.19,223.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.26,223.83s7.2,6,12.72,8.2,14,2.06,15.21-.81-2.1-25.6-4.95-31.58-5.89-6.08-10.92-6.54-15.09,3.64-16.86,8.5.25,11.74,1.71,15.82A30,30,0,0,0,206.26,223.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.78,209c.12,2.88-1.69,5.29-4,5.38s-4.33-2.16-4.44-5,1.69-5.29,4-5.39S229.67,206.09,229.78,209Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,207.88c.12,2.88-.81,5.25-2.07,5.3s-2.38-2.24-2.49-5.12.82-5.26,2.08-5.31S235.33,205,235.44,207.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.08,207.94s8.26,1.57,7.46,3.56-6.38,4.14-6.38,4.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.57,207s.12-1,1.39-.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.08,
    y1: 209.78,
    x2: 206.06,
    y2: 215.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.28,204.92a3.81,3.81,0,0,1,3.74-2.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.28,
    y1: 202.73,
    x2: 228.97,
    y2: 203.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.14,219.5s3-.78,4.7,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.07,209.52c.14,1,0,1.86-.41,1.91s-.77-.72-.91-1.73.05-1.85.42-1.9S225.94,208.52,226.07,209.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,215.73s-1,2,1.82,2.1,4.74-1.27,3.37-3-3.4-3.35-1.31-5.61,6.15-4.16,3.87-6.68-10.67-.23-8.57-2.27,11.8-4.17,16.16-3.9,12.5-3.11,14.29-7.53-.71-12.59-6.57-12.15-10.23,5.63-12.83,6-7.93-2.52-12.4,0-4.62,9.76-5,10.65-6.44,2.21-7.51,8.34A16.34,16.34,0,0,0,197,215.49c2.51,2.73,3.64,3.77,3.64,3.77Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.74,204.65a4.75,4.75,0,0,0,.64,2.66",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23,188.82s-2.18-4.77,3.38-4.77,6.36,7,.6,9.54-18.29,3.18-25.05,6.17a8.79,8.79,0,0,0-3.44,2.43",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.16,205.76c-2,.72-4.59,1.72-7.22,2.94-5.57,2.59-4.38,5.17-4.38,5.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87,204.53s-.49.14-1.32.41",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,217.87s-3.23-4.66-6.63-2.79-.76,8.52,1.29,10.83,6-2,6.41-3.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-15--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.41,217.87s-3.23-4.66-6.63-2.79-.76,8.52,1.29,10.83,6-2,6.41-3.08",
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,217.87s-3.23-4.66-6.63-2.79-.76,8.52,1.29,10.83,6-2,6.41-3.08",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,217.87s-3.23-4.66-6.63-2.79-.76,8.52,1.29,10.83,6-2,6.41-3.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.82,
    y: 213.62,
    width: 81.92,
    height: 62.64,
    rx: 5.12,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "171.18 258.68 219.18 271.18 171.18 247.68",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.44,
    y: 219.64,
    width: 19.27,
    height: 50.6,
    style: {
      fill: "#92BFE3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.08,
    y: 219.64,
    width: 2.41,
    height: 50.6,
    style: {
      fill: "#92BFE3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.08,
    y: 242.77,
    width: 2.41,
    height: 4.32,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.74,
    y1: 220.84,
    x2: 160.69,
    y2: 220.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.74,
    y1: 226.26,
    x2: 160.69,
    y2: 226.26,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.74,
    y1: 231.69,
    x2: 160.69,
    y2: 231.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.74,
    y1: 237.11,
    x2: 160.69,
    y2: 237.11,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.74,
    y1: 250.36,
    x2: 160.69,
    y2: 250.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.74,
    y1: 255.18,
    x2: 160.69,
    y2: 255.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.74,
    y1: 260,
    x2: 160.69,
    y2: 260,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.74,
    y1: 270,
    x2: 160.69,
    y2: 270,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.44,
    y1: 270.23,
    x2: 116.72,
    y2: 219.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.87,
    cy: 402.76,
    rx: 16.73,
    ry: 7.5,
    style: {
      fill: "#92BFE3"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.87,
    cy: 402.76,
    rx: 16.73,
    ry: 7.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3,291.78c1.79.78,6.17.68,6.17.68s-.94-2.87-1-3c-1-2-4-5.33-6.47-5a3,3,0,0,0-2.37,3.7C365,289.84,366.77,291.11,368.3,291.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66,276.87c-2.48-.26-5.43,3.13-6.34,5.17-.08.18-1,3.07-.94,3.07h.05c-.47.53-1,1.11-1.49,1.75-1,1.19-2.06,2.54-3.14,4.1a51.46,51.46,0,0,0-3.25,5.18,38.47,38.47,0,0,0-2.78,6.26.19.19,0,0,0,0,.08c0-.73,0-2.78,0-2.94-.29-2.2-2.14-6.31-4.6-6.76a3,3,0,0,0-3.4,2.78c-.14,1.75,1.13,3.51,2.37,4.62,1.4,1.25,5.28,2.46,5.59,2.55a54.11,54.11,0,0,0-1.64,6.78c-.24,1.34-.43,2.69-.62,4.05,0-.64,0-1.2,0-1.28-.29-2.21-2.14-6.31-4.59-6.76a3,3,0,0,0-3.41,2.77c-.14,1.76,1.13,3.51,2.37,4.62s4.55,2.23,5.43,2.51c-.06.52-.13,1-.2,1.56-.3,2.5-.58,5-.94,7.45-.13.86-.28,1.7-.43,2.54,0-.56,0-1,0-1.1-.29-2.21-2.14-6.31-4.6-6.77a3,3,0,0,0-3.4,2.78c-.14,1.76,1.13,3.51,2.37,4.62s4.23,2.12,5.27,2.45c-.18.86-.37,1.72-.58,2.55-.16.56-.28,1.11-.47,1.66s-.35,1.1-.53,1.64c-.37,1-.75,2.1-1.14,3.09-.27.7-.54,1.36-.8,2,.13-.86.36-2.54.36-2.68a11.46,11.46,0,0,0-1.53-5.58,4.73,4.73,0,0,0,0-.65,3,3,0,0,0-3.61-2.5c-2.41.64-3.94,4.87-4.06,7.09,0,.14.08,1.57.15,2.47-.12-.52-.23-1-.36-1.57-.26-1.07-.54-2.13-.84-3.26-.17-.55-.33-1.1-.5-1.65s-.39-1.12-.58-1.69c-.48-1.3-1-2.6-1.61-3.9.94-.22,4.24-1.06,5.57-2.08s2.72-2.67,2.7-4.43a2.94,2.94,0,0,0-3.18-3c-2.49.27-4.64,4.22-5.09,6.4,0,.14-.17,1.74-.24,2.62-.35-.78-.7-1.55-1.08-2.33-1.11-2.23-2.3-4.45-3.48-6.68-.37-.68-.72-1.36-1.07-2.05.33-.07,4.28-1,5.76-2.13,1.32-1,2.72-2.67,2.71-4.43a3,3,0,0,0-3.19-3c-2.48.27-4.63,4.22-5.08,6.4,0,.16-.24,2.47-.27,3.06-.78-1.51-1.54-3-2.24-4.53a52.33,52.33,0,0,1-2.43-6.28c.15,0,4.28-1,5.8-2.14,1.32-1,2.72-2.67,2.71-4.43a3,3,0,0,0-3.19-3c-2.48.27-4.63,4.22-5.08,6.4,0,.18-.26,2.66-.27,3.11,0-.13-.09-.25-.13-.38a37.77,37.77,0,0,1-1.26-6.64c-.14-1.23-.2-2.43-.24-3.59.79-.09,4.37-.57,5.86-1.47s3-2.35,3.18-4.11a3,3,0,0,0-2.84-3.35c-2.5,0-5.07,3.69-5.76,5.8,0,.12-.28,1.33-.45,2.22,0-.53,0-1.07,0-1.57,0-1.88.12-3.61.24-5.14.08-.87.16-1.65.25-2.39.72-.49,3.6-2.53,4.49-4s1.58-3.47.93-5.1a2.94,2.94,0,0,0-4.06-1.67c-2.22,1.14-2.8,5.6-2.44,7.8,0,.19.87,3.1.91,3.08l0,0c-.09.7-.19,1.46-.28,2.28-.15,1.53-.31,3.26-.35,5.16a53.25,53.25,0,0,0,.14,6.11,38.72,38.72,0,0,0,1.14,6.75.19.19,0,0,0,0,.08c-.39-.61-1.55-2.3-1.65-2.42-1.46-1.69-5.26-4.08-7.56-3.11a3,3,0,0,0-1.31,4.19c.85,1.55,2.88,2.31,4.53,2.55,1.85.27,5.76-.86,6.07-.95a53.2,53.2,0,0,0,2.37,6.55c.54,1.25,1.12,2.49,1.72,3.72-.36-.52-.68-1-.73-1-1.46-1.68-5.27-4.08-7.56-3.11a3,3,0,0,0-1.31,4.2c.85,1.54,2.88,2.31,4.52,2.55s5-.66,5.91-.91c.23.47.46.94.7,1.41,1.13,2.26,2.27,4.5,3.32,6.73.37.79.7,1.58,1,2.37-.31-.47-.58-.85-.63-.91-1.46-1.68-5.27-4.08-7.56-3.11a3,3,0,0,0-1.31,4.2c.85,1.54,2.88,2.3,4.52,2.54s4.7-.57,5.75-.86c.32.82.65,1.64.92,2.45.18.55.39,1.07.53,1.64s.31,1.11.47,1.66c.25,1.07.52,2.17.75,3.21.16.73.3,1.42.44,2.12-.36-.79-1.1-2.31-1.17-2.43-1.19-1.89-4.59-4.84-7-4.22a2.94,2.94,0,0,0-1.93,3.95c.6,1.65,2.49,2.71,4.08,3.2,1.76.53,5.64,0,6.12,0,.23,1.16.45,2.29.63,3.36.66,3.7,1.06,6.81,1.31,9,0,.39.08.73.12,1.06h-7.51l2.41,47.1a6.74,6.74,0,0,0,6.73,6.39h0a6.73,6.73,0,0,0,6.72-6.39l2.42-47.1h-7c.05-.11.1-.21.16-.32,1-2,2.29-4.88,3.73-8.39.45-1.11.92-2.31,1.38-3.54.47.1,4.31.88,6.1.47,1.63-.36,3.59-1.28,4.32-2.88a3,3,0,0,0-1.63-4.09c-2.37-.79-6,1.9-7.3,3.69-.08.1-.79,1.35-1.23,2.14.18-.51.37-1,.56-1.52.38-1,.72-2.06,1.1-3.18.16-.54.33-1.09.49-1.65s.3-1.15.45-1.73c.32-1.35.58-2.73.81-4.13.9.33,4.12,1.45,5.79,1.33s3.74-.73,4.7-2.2a3,3,0,0,0-1-4.28c-2.22-1.15-6.19,1-7.77,2.53-.1.1-1.11,1.36-1.65,2.06.14-.85.27-1.69.38-2.54.31-2.48.54-5,.78-7.5l.24-2.29c.32.12,4.12,1.53,6,1.4,1.66-.12,3.74-.73,4.7-2.2a3,3,0,0,0-1-4.28c-2.22-1.15-6.2,1-7.77,2.53-.12.12-1.57,1.93-1.91,2.41.17-1.69.37-3.37.63-5a52.68,52.68,0,0,1,1.43-6.59c.15.06,4.11,1.55,6,1.41,1.66-.11,3.74-.72,4.7-2.2a3,3,0,0,0-1-4.28c-2.22-1.14-6.19,1-7.77,2.54-.12.12-1.68,2.07-1.93,2.44,0-.12.06-.26.1-.38a37.8,37.8,0,0,1,2.61-6.24c.56-1.11,1.17-2.14,1.78-3.12.71.35,4,1.93,5.7,2s3.79-.31,4.91-1.67a3,3,0,0,0-.51-4.37c-2.08-1.38-6.26.28-8,1.67-.09.08-1,1-1.6,1.6l.84-1.33c1.05-1.57,2.1-2.94,3-4.15.54-.69,1.05-1.29,1.52-1.86.88,0,4.41-.12,5.95-.84s3.23-2,3.6-3.75A3,3,0,0,0,425.66,276.87Zm-27.47,66.64c-1.5,3.45-2.88,6.27-3.87,8.22l-.54,1.07h-.17c-.05-.38-.1-.8-.17-1.27-.3-2.2-.77-5.33-1.51-9-.24-1.18-.51-2.44-.8-3.72a35.28,35.28,0,0,0,3.42-1.6,21.15,21.15,0,0,0,5,3.2C399.07,341.46,398.63,342.52,398.19,343.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.59,292.74s.79-2.91.82-3.1c.31-2.21-.4-6.65-2.64-7.74a3,3,0,0,0-4,1.78c-.6,1.66.16,3.69,1.07,5.09C408.88,290.41,412.58,292.74,412.59,292.74Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.44f10dd8856adc956b4c5b7b7738dd9e.svg";
export { ForwardRef as ReactComponent };